import {
  FaBoxOpen,
  FaBuilding,
  FaDatabase,
  FaGavel,
  FaGlobeAmericas,
  FaHome,
  FaImage,
  FaImages,
  FaIndustry,
  FaLayerGroup,
  FaShip,
  FaSignInAlt,
  FaSitemap,
  FaTags,
  FaTh,
} from "react-icons/fa";

const BASE = "/super-admin/master-data";

export const SUPER_ADMIN_HOME_PAGE_ITEMS = [
  {
    id: "home_section_management",
    label: "Home Section Management",
    to: `${BASE}/home-section-management`,
    icon: FaHome,
    end: true,
  },
  {
    id: "service_quick_links",
    label: "Service Quick Links",
    to: `${BASE}/service-quick-links`,
    icon: FaTh,
    end: true,
  },
  {
    id: "trading_categories",
    label: "Trending Categories",
    to: `${BASE}/trading-categories`,
    icon: FaSitemap,
    end: true,
  },
  {
    id: "featured_category_showcase",
    label: "Featured Category Showcase",
    to: `${BASE}/featured-category-showcase`,
    icon: FaLayerGroup,
    end: true,
  },
  {
    id: "top_industries",
    label: "Top Industries",
    to: `${BASE}/top-industries`,
    icon: FaIndustry,
    end: true,
  },
  {
    id: "banner_management",
    label: "Banner Management",
    to: `${BASE}/banner-management`,
    icon: FaImages,
    end: true,
  },
];

export const SUPER_ADMIN_AUTH_PAGE_ITEMS = [
  {
    id: "platform_logo_management",
    label: "Platform Logo",
    to: `${BASE}/platform-logo`,
    icon: FaImage,
    end: true,
  },
  {
    id: "auth_hero_management",
    label: "Auth Hero Image",
    to: `${BASE}/auth-hero-image`,
    icon: FaImages,
    end: true,
  },
];

export const SUPER_ADMIN_CORE_MASTER_DATA_ITEMS = [
  {
    id: "master_category_management",
    label: "Category Management",
    to: `${BASE}/category-management`,
    icon: FaTags,
    end: true,
  },
  {
    id: "location_management",
    label: "Location Management",
    to: `${BASE}/location-management`,
    icon: FaGlobeAmericas,
    end: true,
  },
  {
    id: "factory_master_management",
    label: "Factory Master Management",
    to: `${BASE}/factory-master-management`,
    icon: FaShip,
    end: true,
  },
  {
    id: "auction_category_management",
    label: "Auction Category Management",
    to: `${BASE}/auction-category-management`,
    icon: FaGavel,
    end: true,
  },
  {
    id: "cm_industry_type_management",
    label: "CM Industry Type Management",
    to: `${BASE}/cm-industry-type-management`,
    icon: FaIndustry,
    end: true,
  },
  {
    id: "facility_category_management",
    label: "Infrastructure Category Management",
    to: `${BASE}/facility-category-management`,
    icon: FaBuilding,
    end: true,
  },
  {
    id: "product_bulk_upload",
    label: "Product Bulk Upload",
    to: `${BASE}/product-bulk-upload`,
    icon: FaBoxOpen,
    end: true,
  },
];

export const SUPER_ADMIN_HOME_PAGE_GROUP = {
  id: "home_page_management",
  heading: "Home Page Management",
  icon: FaHome,
  items: SUPER_ADMIN_HOME_PAGE_ITEMS,
};

export const SUPER_ADMIN_AUTH_PAGE_GROUP = {
  id: "auth_page_management",
  heading: "Auth Page Management",
  icon: FaSignInAlt,
  items: SUPER_ADMIN_AUTH_PAGE_ITEMS,
};

export const SUPER_ADMIN_MASTER_DATA_GROUP = {
  id: "master_data",
  heading: "Master Data",
  icon: FaDatabase,
  items: SUPER_ADMIN_CORE_MASTER_DATA_ITEMS,
};

export const SUPER_ADMIN_MASTER_DATA_GROUPS = [
  SUPER_ADMIN_HOME_PAGE_GROUP,
  SUPER_ADMIN_AUTH_PAGE_GROUP,
  SUPER_ADMIN_MASTER_DATA_GROUP,
];

export const SUPER_ADMIN_MASTER_DATA_ITEMS = [
  ...SUPER_ADMIN_HOME_PAGE_ITEMS,
  ...SUPER_ADMIN_AUTH_PAGE_ITEMS,
  ...SUPER_ADMIN_CORE_MASTER_DATA_ITEMS,
];

export const isSuperAdminMasterDataPath = (pathname = "") =>
  pathname.startsWith(`${BASE}/`) || pathname === BASE;
